import { forwardRef, useImperativeHandle, useRef } from "react";
import { PropertyRow } from "../PropertyUpdateRowInput";
import { useTranslation } from "react-i18next";
import { ToggleSwitch } from "@etframework/ui.components";

export const BooleanUpdateInput = forwardRef(
  ({ change, field, settings, onRemove, value = true, id }, ref) => {
    const { t } = useTranslation(["BulkUpdateTasksModal", "Shared"], {
      useSuspense: false,
    });

    const compRef = useRef(null);

    useImperativeHandle(ref, () => ({
      focus: () => compRef.current.focusIn(),
      applyValue: (properties) => {
        properties[field] = compRef.current?.properties.checked;
      },
      getValue: () => ({
        field: field,
        value: !!compRef.current?.properties.checked,
        hasValue: true,
        settings: settings,
      }),
    }));

    return (
      <PropertyRow
        key={field}
        field={field}
        onRemove={onRemove}
        settings={settings}
      >
        <div
          className={`d-flex gap-4 w-100 ${
            !settings.descriptionText && "align-items-center"
          }`}
        >
          <ToggleSwitch
            ref={compRef}
            id={id}
            value={field}
            name={field}
            checked={value}
            change={change}
          />
          <div className="d-flex flex-column gap-2">
            <span className="fw-600">
              {settings.noTranslations
                ? settings.headerText ?? field
                : t(`Columns.${settings.headerText ?? field}`)}
            </span>
            <span>{settings.descriptionText}</span>
          </div>
        </div>
      </PropertyRow>
    );
  }
);
